/**
 * @file ProgressOverlay.jsx
 * @description A full-screen loading overlay component that renders a semi-transparent
 *              backdrop with a centred MUI CircularProgress spinner inside a Paper card.
 *              Intended to be conditionally rendered during async operations to block UI
 *              interaction and indicate background activity.
 *
 * @component ProgressOverlay
 */
import React from "react";
import { Box, CircularProgress, Paper } from "@mui/material";

const ProgressOverlay = () => {
	return (
		<Box
			sx={{
				position: "fixed",
				top: 0,
				left: 0,
				width: "100vw",
				height: "100vh",
				bgcolor: "rgba(0, 0, 0, 0.5)",
				zIndex: 1300,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Paper
				elevation={1}
				sx={{
					p: 2,
					borderRadius: 3,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					minWidth: 35,
					minHeight: 35,
				}}
			>
				<CircularProgress size={30} color="primary" />
			</Paper>
		</Box>
	);
};

export default ProgressOverlay;
